var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"dashboard-view"},[_c('div',{staticClass:"page-wrapper"},[_c('PageMenu',{staticClass:"page-menu",attrs:{"menu":_vm.menu,"highlightExactRoute":false}}),_c('div',{staticClass:"page-content"},[_c('keep-alive',[_c('router-view')],1)],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }